/**
 * Smart banner component which will decide when itself will show on top of page
 * The banner will show when it is mobile and consumer user
 * Probably different texts based on whether user has native app installed
 */
import PropTypes from 'prop-types'

import React from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import SmartBanner from 'react-smartbanner'
import { trackLink } from '../../lib/analytics/fpti'
import content from 'pp-react-l10n'
let i18n = content('transfer/appBanner')

export class AppBanner extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    isAndroid: PropTypes.bool.isRequired,
    isiPhone: PropTypes.bool.isRequired,
    showAppBanner: PropTypes.bool.isRequired,
    pageName: PropTypes.string,
    pageName2: PropTypes.string,
  }

  render() {
    const { isiPhone, isAndroid, showAppBanner } = this.props

    if (!showAppBanner) {
      return null
    }

    let buttonText = i18n('appBanner.install')
    const storeText = {
      ios: i18n('appBanner.description.ios'),
      android: i18n('appBanner.description.android'),
    }
    // Days to hide banner after close button is clicked
    const daysHidden = 90
    // Days to hide banner after "VIEW" button is clicked
    const daysReminder = 30

    let force = ''
    if (isAndroid) {
      force = 'android'
    }
    if (isiPhone) {
      force = 'ios'
    }
    const appMeta = {
      ios: 'custom-apple-app', // avoid 'apple-itunes-app' so that ios native banner will not show
      android: 'google-play-app',
    }

    return (
      <SmartBanner
        title="PayPal App"
        storeText={storeText}
        force={force}
        daysHidden={daysHidden}
        daysReminder={daysReminder}
        button={buttonText}
        appMeta={appMeta}
        onClose={this.onClose}
        onInstall={this.onInstall}
      />
    )
  }

  onClose = () => {
    trackLink(
      'closeAppBanner',
      this.props.pageName,
      this.props.pageName2,
      'link'
    )
  }

  onInstall = () => {
    trackLink(
      'installFromAppBanner',
      this.props.pageName,
      this.props.pageName2,
      'link'
    )
  }
}

export default connect(({ server }) => ({
  showAppBanner: server.showAppBanner,
  isiPhone: server.isiPhone,
  isAndroid: server.isAndroid,
}))(AppBanner)
